import type { Role } from "@datamole/lssa-permissions";
import { unique } from "radash";

export const roleToViewMap: Record<Role, string[]> = {
    fmsAdvisor: ["fmsAdvisor"],
    tssTechnician: ["technician"],
    tssTeamLead: ["teamLead", "technician"],
    serviceManager: ["serviceManager"],
};

export const getGrantedViewIds = (assignedRoles: Role[]): string[] => {
    return unique(
        assignedRoles.flatMap((role) => roleToViewMap[role] ?? []),
        (viewId) => viewId,
    );
};

export const resolveActiveView = (assignedRoles: Role[], persistedActiveView: string | null): string | null => {
    const grantedViewIds = getGrantedViewIds(assignedRoles);
    if (persistedActiveView && grantedViewIds.includes(persistedActiveView)) {
        return persistedActiveView;
    }
    return grantedViewIds[0] ?? null;
};
